module.exports = __webpack_public_path__ + "media/images/bus/discount-d1b205d6995cafcc2f665bc3f16a7754.svg";